import type { HumanStatusResponse } from '../../sessionClient';

export type HumanStatus = 'password' | 'magic-link' | 'new';

/**
 * A generated (server-side) password means the account has no password the
 * customer knows, so route it to the magic-link step rather than a password
 * prompt; a real password routes to the password step. Mirrors the legacy
 * saga's `hasAutoGeneratedPassword`/`isNewHuman` routing.
 *
 * A leaf on purpose: both the entry step and the registration-conflict re-check
 * answer the same question, so neither owns the mapping.
 */
export function humanStatusToStep({
  isNewHuman,
  hasGeneratedPassword,
}: HumanStatusResponse): HumanStatus {
  if (isNewHuman) {
    return 'new';
  }
  if (hasGeneratedPassword) {
    return 'magic-link';
  }
  return 'password';
}
